import React from "react";
import Nav from "./common/Nav";
import Footer from "./common/Footer";

const PrivacyPolicy = () => {
    return (
        <div>
            <Nav />
            <section className="brdcrm">
                <h2>Privacy Policy</h2>
            </section>
            <section className="privacy_policy">
                <div className="container">
                    <p>“SMS opt-in consent or phone numbers for SMS purposes will NOT be shared with third parties and affiliates for marketing purposes.”. It is crucial that the SMS consent is not shared under any circumstances.</p>
                    <h5>Terms and Conditions</h5>
                    <p>By subscribing to our services, you agree to the following terms and conditions regarding messaging and communications.</p>
                    <h5>Messaging Frequency</h5>
                    <p>By opting in, you consent to receive recurring messages from us. The frequency of these messages may vary depending on the service you’re subscribed to (e.g., weekly, monthly, or as events or promotions arise).</p>
                    <div className="row text-center">
                        <div className="col-lg-6">
                            <h5>Potential Fees</h5>
                            <p>Standard messaging and data rates may apply depending on your mobile carrier and plan. You are responsible for any charges incurred from receiving messages.

                            </p>
                        </div>
                        <div className="col-lg-6">
                            <h5>Opt-In Method
                            </h5>
                            <p>To opt-in to our messaging service, you must provide explicit consent by (START) through our website.

                            </p>
                        </div>
                    </div>
                    <h5>Opt-Out Method
                    </h5>
                    <p>You can opt out of receiving further messages at any time by replying with (STOP). After opting out, you will no longer receive further messages unless you opt back in.

                    </p>
                    <h5>Privacy Policy
                    </h5>
                    <p>For more information about how we collect, use, and protect your personal data, please refer to our Privacy Policy.
                    </p>
                    <p>By subscribing to our messaging service, you acknowledge and agree to these terms.

                    </p>
                    <p>If you require further assistance, please chat with us by visiting <b>https://www.goldenstatemover.com</b>. You can also reach us by calling 408 215 6348 and selecting option 3. We values your privacy and is committed to protecting your personal information. This Privacy Policy describes how we collect, use, disclose, and protect your personal information when you visit our website or use our services.
                    </p>
                    <h5>Information We Collect
                    </h5>
                    <p>We collect different types of personal information depending on how you interact with our services:
                    </p>
                    <ul>
                        <li>When you request a quote, purchase insurance, or communicate with us, we may collect your name, contact details (email, phone number, address), insurance policy details, and payment information.</li>

                        <li>When you use our website, we automatically gather information about your device, IP address, browser type, and how you interact with the site, including pages viewed, time spent, and referring URLs.</li>

                        <li>Any communication you have with us—via phone, email, or online chat—may be recorded and stored for quality assurance, training, or to help fulfill your requests.</li>

                        <li>We use cookies, web beacons, and similar technologies to personalize your experience, improve our services, and track user activity on our website.</li>
                    </ul>
                    <h5>How We Use Your Information
                    </h5>
                    <p>We use the personal information we collect from you for various purposes, including but not limited to:

                    </p>
                    <ul>
                        <li>To process insurance applications.</li>
                        <li>To respond to inquiries, process requests, and provide necessary customer service.</li>
                        <li>To send you relevant offers, promotions, or newsletters based on your preferences (with opt-out options available).</li>
                        <li>To monitor how our website is used, improve its functionality, and develop new products and services.</li>
                        <li>To protect against fraud, unauthorized access, and other threats, and to comply with legal or regulatory requirements.</li>
                    </ul>
                    <h5>Sharing and Disclosure of Information
                    </h5>
                    <ul>
                        <li>We respect your privacy and will not sell, rent, or share your personal information for marketing purposes without your consent. However, we may share your information in the following circumstances
                        </li>
                        <li>We work with trusted third-party vendors to provide services such as data analysis, payment processing, email delivery, and customer support. These providers are obligated to protect your personal information and use it only for the purposes we define.
                        </li>
                        <li>We may disclose your personal information if required by law or in response to legitimate requests from regulatory authorities or courts.
                        </li>
                        <li>In the event of a merger, acquisition, or sale of all or part of our assets, your personal information may be transferred to the new business entity as part of the transaction.
                        </li>
                    </ul>
                    <h5>Data Security
                    </h5>
                    <p>We take your data security seriously and implement various administrative, technical, and physical security measures to protect your personal information. These safeguards are designed to prevent unauthorized access, misuse, or disclosure of your data. However, no method of transmitting or storing data electronically is 100% secure, so we cannot guarantee absolute security.

                    </p>
                    <h5>Cookies and Tracking Technologies
                    </h5>
                    <p>We use cookies and other tracking technologies to personalize your experience on our website and improve its performance. Cookies allow us to remember your preferences, gather analytical data, and deliver relevant advertising.

                    </p>
                    <p>You can control or disable cookies through your browser settings. Please note that disabling cookies may limit your ability to use certain features of our website.

                    </p>
                    <h5>Your Privacy Rights

                    </h5>
                    <p>You have certain rights regarding your personal information, depending on your location and applicable privacy laws. These rights may include:

                    </p>
                    <ul>
                        <li>You can request a copy of the personal data we hold about you.</li>
                        <li>You can request that we update or correct any inaccurate personal data.</li>
                        <li>Under certain circumstances, you may request that we delete your personal data.</li>
                        <li>In specific situations, you may request that we limit how your personal data is used.</li>
                        <li>You can request your personal information in a commonly used, machine-readable format.</li>
                        <li>You may object to the processing of your personal data for certain purposes, including marketing.</li>
                    </ul>
                    <p>To exercise any of these rights, please contact us using the information provided in the “Contact Us” section below.

                    </p>
                    <h5>Third-Party Websites

                    </h5>
                    <p>Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of those sites. We encourage you to review their privacy policies before providing any personal information.

                    </p>
                    <h5>Children’s Privacy

                    </h5>
                    <p>Our services are not directed at children under the age of 13, and we do not knowingly collect personal information from children. If we become aware that we have inadvertently collected personal information from a child, we will take steps to delete it promptly. If you believe we have collected information from a child under 13, please contact us immediately.
                    </p>
                    <h5>Changes to This Privacy Policy

                    </h5>
                    <p>We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. Any updates will be posted on this page, and we encourage you to review it periodically to stay informed about how we are protecting your information.

                    </p>
                    <h5>Contact Us

                    </h5>
                    <p>If you have any questions, concerns, or requests regarding this Privacy Policy or our privacy practices, please contact us.

                    </p>
                </div>
            </section>
            <Footer />
        </div>
    );
}

export default PrivacyPolicy;